import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconCalendar: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 3.125H13.9583V2.5C13.9583 2.155 13.6783 1.875 13.3333 1.875C12.9883 1.875 12.7083 2.155 12.7083 2.5V3.125H7.29167V2.5C7.29167 2.155 7.01167 1.875 6.66667 1.875C6.32167 1.875 6.04167 2.155 6.04167 2.5V3.125H5C2.985 3.125 1.875 4.235 1.875 6.25V15C1.875 17.015 2.985 18.125 5 18.125H15C17.015 18.125 18.125 17.015 18.125 15V6.25C18.125 4.235 17.015 3.125 15 3.125ZM5 4.375H6.04167V5C6.04167 5.345 6.32167 5.625 6.66667 5.625C7.01167 5.625 7.29167 5.345 7.29167 5V4.375H12.7083V5C12.7083 5.345 12.9883 5.625 13.3333 5.625C13.6783 5.625 13.9583 5.345 13.9583 5V4.375H15C16.3142 4.375 16.875 4.93583 16.875 6.25V6.875H3.125V6.25C3.125 4.93583 3.68583 4.375 5 4.375ZM15 16.875H5C3.68583 16.875 3.125 16.3142 3.125 15V8.125H16.875V15C16.875 16.3142 16.3142 16.875 15 16.875ZM7.51668 10.8333C7.51668 11.2933 7.14418 11.6667 6.68335 11.6667C6.22335 11.6667 5.84574 11.2933 5.84574 10.8333C5.84574 10.3733 6.21501 10 6.67501 10H6.68335C7.14335 10 7.51668 10.3733 7.51668 10.8333ZM10.85 10.8333C10.85 11.2933 10.4775 11.6667 10.0167 11.6667C9.55668 11.6667 9.17908 11.2933 9.17908 10.8333C9.17908 10.3733 9.54834 10 10.0083 10H10.0167C10.4767 10 10.85 10.3733 10.85 10.8333ZM14.1833 10.8333C14.1833 11.2933 13.8108 11.6667 13.35 11.6667C12.89 11.6667 12.5124 11.2933 12.5124 10.8333C12.5124 10.3733 12.8817 10 13.3417 10H13.35C13.81 10 14.1833 10.3733 14.1833 10.8333ZM7.51668 14.1667C7.51668 14.6267 7.14418 15 6.68335 15C6.22335 15 5.84574 14.6267 5.84574 14.1667C5.84574 13.7067 6.21501 13.3333 6.67501 13.3333H6.68335C7.14335 13.3333 7.51668 13.7067 7.51668 14.1667ZM10.85 14.1667C10.85 14.6267 10.4775 15 10.0167 15C9.55668 15 9.17908 14.6267 9.17908 14.1667C9.17908 13.7067 9.54834 13.3333 10.0083 13.3333H10.0167C10.4767 13.3333 10.85 13.7067 10.85 14.1667ZM14.1833 14.1667C14.1833 14.6267 13.8108 15 13.35 15C12.89 15 12.5124 14.6267 12.5124 14.1667C12.5124 13.7067 12.8817 13.3333 13.3417 13.3333H13.35C13.81 13.3333 14.1833 13.7067 14.1833 14.1667Z"
      fill={color}
    />
  </svg>
);

export default IconCalendar;
